<div class="start-container">
	<p class="hint">{{'startButton.hint' | translate}}</p>
	<a (click)="start()" class="btn start-button" data-wow-delay="0.7s">{{ 'startButton.title' | translate}}</a>	
</div>